import styled from 'styled-components'
import EditIcon from '@mui/icons-material/Edit'

export const Container = styled.div`

`

export const Img = styled.img`
    width: 70px;
    height: 70px;
    border-radius: 5px;
    object-fit: cover;
    object-position: 40% 80%;
`

export const EditIconStyle = styled(EditIcon)`
    cursor: pointer;
    color: #323d5d;
`
